class ProductAccoladesCarousel extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('[id^="Slider-"]');
    this.slides = Array.from(this.querySelectorAll('[id^="Slide-"]'));
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dots = Array.from(this.querySelectorAll('.slider-counter__link'));

    if (!this.slider || this.slides.length < 2) return;

    this.currentIndex = 0;

    this.slider.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        this.goTo(index);
      });
    });

    const resizeObserver = new ResizeObserver(() => this.update());
    resizeObserver.observe(this.slider);

    this.update();
  }

  getSlideWidth() {
    return this.slides[0]?.offsetWidth || this.slider.clientWidth;
  }

  getIndexFromScroll() {
    const slideWidth = this.getSlideWidth();
    if (!slideWidth) return 0;
    return Math.round(this.slider.scrollLeft / slideWidth);
  }

  collapseOpenDetails() {
    this.querySelectorAll('[data-accolade-details][open]').forEach((details) => {
      details.open = false;
      const toggle = document.querySelector(`[data-accolade-toggle="${details.id}"]`);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  goTo(index) {
    const clampedIndex = Math.max(0, Math.min(index, this.slides.length - 1));
    const slide = this.slides[clampedIndex];
    if (!slide) return;

    if (clampedIndex !== this.currentIndex) {
      this.collapseOpenDetails();
    }

    this.slider.scrollTo({
      left: slide.offsetLeft,
      behavior: 'smooth',
    });
  }

  onScroll() {
    const newIndex = this.getIndexFromScroll();
    if (newIndex !== this.currentIndex) {
      this.collapseOpenDetails();
      this.currentIndex = newIndex;
    }
    this.update();
  }

  update() {
    const index = this.getIndexFromScroll();
    this.currentIndex = index;

    if (this.prevButton) {
      this.prevButton.hidden = index === 0;
    }
    if (this.nextButton) {
      this.nextButton.hidden = index >= this.slides.length - 1;
    }

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('slider-counter__link--active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }
}

customElements.define('product-accolades-carousel', ProductAccoladesCarousel);
